import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail, RefreshCw } from "lucide-react";
import { supabase } from "../lib/supabase";

export default function EmailPreviewPage() {
  const [templates, setTemplates] = useState([]);
  const [activeTemplate, setActiveTemplate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("email_templates")
      .select("template_name, subject, html_content");

    if (data && data.length > 0) {
      setTemplates(data);
      setActiveTemplate(data[0]);
    }
    setLoading(false);
  };

  const getLabel = (name) => {
    const labels = {
      client_signup: "Клиент",
      expert_signup: "Эксперт",
      universal_signup: "Универсальный",
      password_recovery: "Сброс пароля",
      expert_invite: "Приглашение"
    };
    return labels[name] || name;
  };

  const prepareHtml = (html) => {
    if (!html) return "";
    let processed = html;
    processed = processed.replace(
      /\{\{\s*\.ConfirmationURL\s*\}\}/g,
      "#"
    );
    processed = processed.replace(
      /\{\{INVITE_CODE\}\}/g,
      "OBS-EXAMPLE1"
    );
    processed = processed.replace(
      /\{\{EXPIRES_DATE\}\}/g,
      new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toLocaleDateString("ru-RU", { day: "numeric", month: "long", year: "numeric" })
    );
    processed = processed.replace(
      /\{\{REGISTER_URL\}\}/g,
      "#"
    );
    processed = processed.replace(
      /\{\{[^}]*\}\}/g,
      ""
    );
    return processed;
  };

  return (
    <div id="email-preview_page" className="min-h-screen bg-neutral-950">
      <div className="max-w-5xl mx-auto px-4 py-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-neutral-400 hover:text-white mb-8 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          <span className="text-lg font-extralight">На главную</span>
        </Link>

        <div className="flex items-center gap-3 mb-8">
          <Mail className="w-8 h-8 text-primary-400" />
          <div>
            <h1 className="text-3xl font-medium text-white">
              Превью email-шаблонов
            </h1>
            <p className="text-lg font-extralight text-neutral-400">
              Шаблоны из базы данных Supabase
            </p>
          </div>
        </div>

        {loading ? (
          <div className="text-center py-20">
            <RefreshCw className="w-8 h-8 text-neutral-500 animate-spin mx-auto mb-4" />
            <p className="text-lg font-extralight text-neutral-400">
              Загрузка шаблонов...
            </p>
          </div>
        ) : templates.length === 0 ? (
          <div className="text-center py-20 p-6 rounded-md bg-neutral-900/50 border border-neutral-800">
            <Mail className="w-12 h-12 text-neutral-600 mx-auto mb-4" />
            <p className="text-lg font-extralight text-neutral-400">
              Шаблоны не найдены
            </p>
          </div>
        ) : (
          <>
            <div className="flex flex-wrap gap-3 mb-6">
              {templates.map((tpl) => (
                <button
                  key={tpl.template_name}
                  onClick={() => setActiveTemplate(tpl)}
                  className={`flex items-center gap-2 px-5 py-3 rounded-md text-lg font-extralight transition-colors ${
                    activeTemplate?.template_name === tpl.template_name
                      ? "bg-primary-600/20 text-primary-400 border border-primary-600/40"
                      : "bg-neutral-900/50 text-neutral-400 border border-neutral-800 hover:bg-neutral-800"
                  }`}
                >
                  <Mail className="w-4 h-4" />
                  {getLabel(tpl.template_name)}
                </button>
              ))}
            </div>

            {activeTemplate && (
              <div className="space-y-4">
                <div className="p-4 rounded-md bg-neutral-900/50 border border-neutral-800">
                  <p className="text-lg font-extralight text-neutral-500 mb-1">
                    Тема письма:
                  </p>
                  <p className="text-lg font-extralight text-white">
                    {activeTemplate.subject}
                  </p>
                </div>

                <div className="rounded-md border border-neutral-800 overflow-hidden bg-neutral-900/30">
                  <div className="px-4 py-3 border-b border-neutral-800 flex items-center justify-between">
                    <span className="text-lg font-extralight text-neutral-400">
                      Превью
                    </span>
                    <span className="text-lg font-extralight text-neutral-600">
                      {activeTemplate.template_name}
                    </span>
                  </div>
                  <div className="flex justify-center p-4 bg-[#0a0a0a]">
                    <iframe
                      title="Email Preview"
                      srcDoc={prepareHtml(activeTemplate.html_content)}
                      className="w-full max-w-[640px] border-0 rounded"
                      style={{ minHeight: "800px", background: "#0a0a0a" }}
                    />
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
